import * as React from "react";

import { SignupAgentCarousel } from "@v2/features/account/product-showcase-panel/ProductShowcasePanel";

export function BetaShowcasePanel({ className }: { className?: string }) {
  return <SignupAgentCarousel onSwitchPath={null} className={className} />;
}
